import { createApiSlice } from "@common";
import {
  CURD_CLOSURE_REASON
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addClosureReason",
    method: "post",
    url: CURD_CLOSURE_REASON,
    stateKey: "message",
  },
  {
    name: "getClosureReason",
    method: "get",
    url: CURD_CLOSURE_REASON,
    stateKey: "data",
  },
  {
    name: "updateClosureReason",
    method: "put",
    url: CURD_CLOSURE_REASON,
    stateKey: "message",
  },
  {
    name: "deleteClosureReason",
    method: "delete",
    url: CURD_CLOSURE_REASON,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "closureReason",
  apiConfig,
  customReducers,
);
const closureReasonSlice = slice;
// Export the slice's reducer
export default closureReasonSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addClosureReason,
  getClosureReason,
  updateClosureReason,
  deleteClosureReason
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
